export const router = {
  state: {
    location: {
      pathname: '',
    },
    history: {},
    match: {},
  },
  reducers: {
    updateRouter(state, { location, history, match }) {
      return { location, history, match };
    },
  },
  effects: () => ({}),
};
